import React from "react";
//components
import SwiperList from "../../common/components/SwiperList/SwiperList";
import AlbumSliderContainer from "../../containers/AlbumSliderContainer/AlbumSliderContainer";
import SideBarNavigation from "../../parts/SideBarNavigation/SideBarNavigation";
import Header from "../../parts/Header/Header";
import FlexLayout from "../../common/layout/FlexLayout/FlexLayout";
import Footer from "../../parts/Footer/Footer";

import MusicPlayer from "../../MusicPlayer/components/MusicPlayer";
import { Grid } from "@mui/material";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
const MainContent = React.lazy(() => {
  return import("../../components/MainContent/MainContent");
});
const Discover = () => {
  return (
    <React.Suspense fallback>
      <MainContent />
    </React.Suspense>
  );
};
export default Discover;
